const setFooterDate = () => {
  const footerDateEl = document.querySelector('.footer-date');
  footerDateEl.textContent = new Date().getFullYear();
}

setFooterDate();